import { getInterFontWeightCSS } from '@prophecy/theme';
import styled, { css } from 'styled-components';

import { tokens } from './tokens';
import { BaseTypographyProps, CodeLevels, TextLevels, DisplayLevels } from './types';

export const baseDisplayTypographyCss = css<BaseTypographyProps<DisplayLevels>>`
  all: unset;
  font-family: ${tokens.Display.fontFamily};
  font-size: ${(props) => tokens.Display.level[props.level].fontSize};
  line-height: ${(props) => tokens.Display.level[props.level].lineHeight};
  ${({ weight }) => getInterFontWeightCSS(weight || tokens.Display.fontWeight)};
  color: ${({ tone }) => (tone ? tone : 'inherit')};
  letter-spacing: ${tokens.Display.letterSpacing};
  font-style: ${({ italic }) => (italic ? 'italic' : 'normal')};
`;
export const BaseDisplay = styled.span<BaseTypographyProps<DisplayLevels>>`
  ${baseDisplayTypographyCss}
`;
export const baseTextTypographyCss = css<BaseTypographyProps<TextLevels>>`
  all: unset;
  font-family: ${tokens.Text.fontFamily};
  font-size: ${(props) => tokens.Text.level[props.level].fontSize};
  line-height: ${(props) => tokens.Text.level[props.level].lineHeight};
  ${({ weight }) => getInterFontWeightCSS(weight || tokens.Text.fontWeight)};
  color: ${({ tone }) => (tone ? tone : 'inherit')};
  letter-spacing: ${tokens.Text.letterSpacing};
  font-style: ${({ italic }) => (italic ? 'italic' : 'normal')};
`;

export const BaseText = styled.span<BaseTypographyProps<TextLevels>>`
  ${baseTextTypographyCss}
`;

export const baseCodeTypographyCss = css<BaseTypographyProps<CodeLevels>>`
  all: unset;
  font-family: ${tokens.Code.fontFamily};
  font-size: ${tokens.Code.level.sm13.fontSize};
  line-height: ${tokens.Code.level.sm13.lineHeight};
  letter-spacing: ${tokens.Code.letterSpacing};
  font-weight: ${({ weight }) => (weight ? weight : tokens.Code.fontWeight)};
  color: ${({ tone }) => (tone ? tone : 'inherit')};
`;
export const BaseCode = styled.span<BaseTypographyProps<CodeLevels>>`
  ${baseCodeTypographyCss}
`;

export const StyledCodeBlock = styled.code`
  /** EMs are specifically given so it depends on parent font size */
  padding: 0.2em 0.4em 0.1em;
  margin: 0 0.2em;
  font-size: 0.85em;
  background: ${tokens.CodeBlock.backgroundColor};
  border: 1px solid ${tokens.CodeBlock.borderColor};
  border-radius: ${tokens.CodeBlock.borderRadius};
`;
